export default "__VITE_ASSET__CLt9YAlT__"